import script from "./email-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-check.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__